import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const DateIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M7.99844 3.00079C8.55073 3.00079 8.99844 3.44851 8.99844 4.00079V5.00079H14.9984V4.00079C14.9984 3.44851 15.4462 3.00079 15.9984 3.00079C16.5507 3.00079 16.9984 3.44851 16.9984 4.00079V5.00079H17.9984C19.6553 5.00079 20.9984 6.34394 20.9984 8.00079V18.0008C20.9984 19.6576 19.6553 21.0008 17.9984 21.0008H5.99844C4.34159 21.0008 2.99844 19.6576 2.99844 18.0008V8.00079C2.99844 6.34394 4.34159 5.00079 5.99844 5.00079H6.99844V4.00079C6.99844 3.44851 7.44616 3.00079 7.99844 3.00079ZM6.99844 7.00079H5.99844C5.44616 7.00079 4.99844 7.44851 4.99844 8.00079V10.0008H18.9984V8.00079C18.9984 7.44851 18.5507 7.00079 17.9984 7.00079H16.9984V8.00079C16.9984 8.55308 16.5507 9.00079 15.9984 9.00079C15.4462 9.00079 14.9984 8.55308 14.9984 8.00079V7.00079H8.99844V8.00079C8.99844 8.55308 8.55073 9.00079 7.99844 9.00079C7.44616 9.00079 6.99844 8.55308 6.99844 8.00079V7.00079ZM18.9984 12.0008H4.99844V18.0008C4.99844 18.5531 5.44616 19.0008 5.99844 19.0008H17.9984C18.5507 19.0008 18.9984 18.5531 18.9984 18.0008V12.0008Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

DateIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(DateIcon);
